// @ts-nocheck
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import _ from 'lodash';
import moment from 'moment-timezone';
/* eslint-disable */

export default class Utils {
  constructor(toastr) {
    'ngInject';

    Object.assign(this, {
      toastr
    });
  }

  get emailRegex() {
    return /^[-a-z0-9%S_+]+(\.[-a-z0-9%S_+]+)*@(?:[a-z0-9-]{1,63}\.){1,125}[a-z]{2,63}$/i;
  }

  get domainRegex() {
    return /^@(?:[a-z0-9-]{1,63}\.){1,125}[a-z]{2,63}$/i;
  }

  leftTrim(string, number_of_characters) {
    return string.slice(0, number_of_characters);
  }

  replaceDotForDash(warning_level) {
    if (warning_level == 2.5) {
      return '2-5';
    } else {
      return warning_level;
    }
  }

  serializeQuery(obj) {
    if (!obj) {
      return '';
    }

    let token = '';

    for (const key in obj) {
      const value = obj[key];
      if (value === null || value === undefined) {
        continue;
      }
      const delimiter = `${!token.length ? '?' : '&'}`;
      token += `${delimiter}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }

    return token;
  }

  // isJson(str) {
  //   try {
  //       JSON.parse(str);
  //   } catch (e) {
  //       return false;
  //   }
  //   return true;
  // }

  isJson(str) {
    try {
      JSON.parse(str, function(k, v) {
        if (k === "" && typeof v === "number") {
          throw "Invalid JSON";
        }
        return v;
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  isValidDomain(domain) {
    return this.domainRegex.test(domain);
  }

  isValidEmail(email) {
    return this.emailRegex.test(email);
  }

  isValidPassword() {}

  isArray(val) {
    return _.isArray(val);
  }

  isString(val) {
    return _.isString(val);
  }

  isObject(val) {
    return _.isObject(val);
  }

  boolToStr(bool) {
    return bool ? '1' : '0';
  }

  humanizeBool(bool) {
    return bool ? 'on' : 'off';
  }

  strToBool(str) {
    if (parseInt(str, 10)) {
      return true;
    }

    return false;
  }

  findDifference(oldObj, newObj) {
    const changes = {};
    let original = angular.copy(oldObj);
    let changed = angular.copy(newObj);

    // Get rid of angular's imposed obj values

    original = JSON.parse(angular.toJson(original));
    changed = JSON.parse(angular.toJson(changed));

    // Set up our recurser
    const merge = (older, newer, parent) => {
      // Merge old and new objects
      _.mergeWith(older, newer, (oldValue, newValue, key) => {
        if (!_.isEqual(oldValue, newValue)) {
          if (_.isObject(newValue)) {
            parent[key] = {};
            merge(oldValue, newValue, parent[key]);
          } else {
            parent[key] = newValue;
          }
        }
      });
    }; // Start the merge


    merge(original, changed, changes);
    return changes;
  }

  encodeISODate(dateStr) {
    const date = new Date(dateStr);
    const yr = date.getFullYear();
    let mo = date.getMonth() + 1;
    let d = date.getDate();

    if (mo.toString().length === 1) {
      mo = `0${mo}`;
    }

    if (d.toString().length === 1) {
      d = `0${d}`;
    }

    return `${yr}-${mo}-${d}T00:00:00+00:00`;
  }

  sortObjectByKeys(unordered) {
    const ordered = {};
    Object.keys(unordered).sort().forEach(key => {
      ordered[key] = unordered[key];
    });
    return ordered;
  }
  /**
   * Returns a stringified error message
   * @param {error} err - http error from server
   * @param {string} defaultMessage - message to return if we cannot unwrap error
   * @returns {string} error message
   */
  getApiErrorMessage(err, defaultMessage = 'Something went wrong, please try again.') {
    if (err && err.data && err.data.message) {
      if (typeof err.data.message === 'string') return err.data.message;
      if (typeof err.data.message === 'object' && err.data.message.summary) return err.data.message.summary;
    }

    // const { message, status } = err.data;

    // if (typeof message === 'string') {
    //   return message;
    // } else if (typeof message === 'object' && 'summary' in message) {
    //   return message.summary;
    // }

    return defaultMessage;
  }

  createErrorToast(err, defaultMessage) {
    const errorMessage = this.getApiErrorMessage(err, defaultMessage);
    return this.toastr.error(errorMessage);
  }

  filterParams(payload, whitelist) {
    const filtered = {};
    for (const key in payload) {
      if (whitelist.indexOf(key) > -1) {
        filtered[key] = payload[key];
      }
    }
    return filtered;
  }

  capitalizer(text) {
    if (!text) return "";

    return text.toString().toLowerCase()
      .replace(/[_-]/g, ' ')
      .replace(/(?:^|\s)\S/g, (a) => {
        return a.toUpperCase();
      });
  }

  getFirstLetterUppercase(string) {
    return string?.charAt(0).toUpperCase() || '';
  }

  buildJsonApiParams(queryParams) {
    let query = '';
    if (queryParams) {
      query += '?';
      for (const [key, value] of Object.entries(queryParams)) {
        if (['filter', 'page'].includes(key)) {
          for (const [qKey, qValue] of Object.entries(value)) {
            query += `&${key}[${qKey}]=${Array.isArray(qValue) ? qValue.join() : qValue}`
          }
        }
        else if (['sort'].includes(key)) {
          query += `&${key}=`;
          let i = 0;
          for (const [qKey, qValue] of Object.entries(value)) {
            i++;
            query += `${qValue === '+' ? '' : '-'}${qKey}${i < Object.keys(queryParams[key]).length ? ',' : ''}`
          }
        }
        else {
          if (![null, undefined, ''].includes(value)) {
            query += `&${key}=${value}`;
          }
        }
      }
      query = query.substring(0,1) +  query.substring(2,query.length);
    }
    return query;
  }

  getMillisecondsToDate() {
    const date = new Date();
    const now = date.getTime();
    return now;
  }

  formatDateToISO(iso_date, timezone) {
    if (!iso_date || !timezone) return "";
    const formatted_date = moment.tz(iso_date, timezone).format('YYYY-MM-DD');
    return formatted_date;
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control?.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  updateFormArray(event:any, array: any) {
    if (event.target.checked) {
      array.push(new FormControl(event.target.value))
    } else {
      let i = 0
      array.controls.forEach((ctrl: any) => {
        if (ctrl.value === event.target.value) {
          array.removeAt(i)
          return
        } else {
          i++
        }
      })
    }
  }

  createUserForm(formBuilder) {
    return formBuilder.group({
      title: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      initials: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      credentials: [''],
      password: ['', Validators.required],
      dob: ['', Validators.required],
      gender: ['', Validators.required],
      security: formBuilder.group({
        question: ['', Validators.required],
        answer: ['', Validators.required]
      }),
      phones: formBuilder.group({
        0: formBuilder.group({
          number: ['', Validators.required]
        })
      }),
      address: formBuilder.group({
        road: ['', Validators.required],
        city: ['', Validators.required],
        state: ['', Validators.required],
        zip: ['', Validators.required]
      }),
      roles: formBuilder.array([])
    });
  }

  parseAmount(amountStr) {
    if (!isNaN(parseFloat(amountStr)) && isFinite(amountStr)) {
      return parseFloat(amountStr);
    }
    const cleanedAmount = amountStr.replace(/[^\d.-]/g, '');
    return parseFloat(cleanedAmount);
  }
}

Utils.$inject = ["toastr"];
